<div
  class="krc20-summary-container flex column justify-content-center align-items-center full-width gap-16"
  appInfiniteScroll
  [scrollThreshold]="config.scrollThreshold"
  [scrollDebounce]="config.debounceMs"
  [greedyLoading]="config.greedyLoading"
  (scrolled)="onScrolled($event)"
  (thresholdReached)="shouldLoadMore(true)"
>
  @if (loading()) {
    <div class="skeleton-loading-container flex column gap-16 full-width">
      @for (skeleton of loadingSkeletons; track i; let i = $index) {
        <div
          class="krc20-summary-container__card card-0 flex full-width align-items-center justify-content-between p-16"
          [style.opacity]="1 - i * 0.15"
        >
          <div
            class="krc20-summary-container__token-info flex align-items-center gap-16"
          >
            <app-skeleton
              [height]="'48px'"
              [width]="'48px'"
              [fullRound]="false"
            />
            <div class="flex column gap-4">
              <app-skeleton
                [height]="'20px'"
                [width]="'120px'"
                [fullRound]="false"
              />
              <app-skeleton
                [height]="'16px'"
                [width]="'80px'"
                [fullRound]="false"
              />
            </div>
          </div>
          <div
            class="krc20-summary-container__usd-info flex column align-items-end gap-4"
          >
            <app-skeleton
              [height]="'20px'"
              [width]="'80px'"
              [fullRound]="false"
            />
            <app-skeleton
              [height]="'16px'"
              [width]="'60px'"
              [fullRound]="false"
            />
          </div>
        </div>
      }
    </div>
  } @else if (tokens().length === 0) {
    <div class="empty-state flex column align-items-center gap-16 p-32">
      <div class="text-gray-60 typo-text-2 text-center">
        No KRC20 tokens found
      </div>
      <div class="text-gray-50 typo-text-1 text-center">
        Tokens will appear here when available
      </div>
    </div>
  } @else {
    <div class="totals-container flex align-items-center gap-8">
      <span class="text-gray-60 typo-text-2">
        Portfolio value: ${{ totalValueUsd() | number: "1.2-2" }}
      </span>
    </div>
    @for (token of tokens(); track trackByToken($index, token)) {
      <krc20-asset-card
        class="krc20-summary-container__card full-width"
        [krc20]="token"
        (cardClick)="onTokenClick(token)"
      />
    }

    <!-- Loading more indicator - portfolio pattern -->
    @if (isLoadingMore() && tokens().length > 0) {
      <div
        class="loading-more-container flex justify-content-center p-16 full-width"
      >
        <div
          class="krc20-summary-container__card card-0 flex full-width align-items-center justify-content-between p-16"
          [style.opacity]="0.7"
        >
          <div
            class="krc20-summary-container__token-info flex align-items-center gap-16"
          >
            <app-skeleton
              [height]="'48px'"
              [width]="'48px'"
              [fullRound]="false"
            />
            <div class="flex column gap-4">
              <app-skeleton
                [height]="'20px'"
                [width]="'120px'"
                [fullRound]="false"
              />
              <app-skeleton
                [height]="'16px'"
                [width]="'80px'"
                [fullRound]="false"
              />
            </div>
          </div>
          <div
            class="krc20-summary-container__usd-info flex column align-items-end gap-4"
          >
            <app-skeleton
              [height]="'20px'"
              [width]="'80px'"
              [fullRound]="false"
            />
            <app-skeleton
              [height]="'16px'"
              [width]="'60px'"
              [fullRound]="false"
            />
          </div>
        </div>
      </div>
    }
  }
</div>
